import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import {
  ReleaseNotesContainer,
  VersionContainer,
} from '../../assets/styles/components/settingsPopover.styled';
import { Paragraph, Spin, Text } from '../Ant';
import { useGetReleaseNotes } from '../../hooks/useGetReleaseNotes';
import { useLanguage } from '../../context/LanguageContext';
import { RELEASE_NOTES_PRODUCT_IDENTIFIER } from '../../constants/constants';
import { Fragment } from 'react/jsx-runtime';
import { ReleaseNote } from '../../interface/releaseNotes';
import { getLocalDateAndTime } from '../../constants/utilityFunctions';
import { useTranslation } from 'react-i18next';
import { Flex } from 'antd';
import { getReleaseNotesForLanguage } from '../../helpers/releaseNotes';

const ReleaseNotes = () => {
  const { t } = useTranslation();
  const { language } = useLanguage();
  const { data: releaseNotes, isLoading } = useGetReleaseNotes({
    productIdentifier: RELEASE_NOTES_PRODUCT_IDENTIFIER,
    language,
    limit: 25,
  });

  return (
    <ReleaseNotesContainer vertical gap={5} className="scroll-to-modal-edge resizable-modal-scroll">
      {isLoading && (
        <Flex justify="center" align="center" className="p-20 w-full">
          <Spin />
        </Flex>
      )}
      {releaseNotes?.length === 0 && !isLoading && (
        <Paragraph $fontsize="14px" $color="description" className="py-20 ta-center">
          {t('common:noReleaseNotes')}
        </Paragraph>
      )}
      {releaseNotes?.length > 0 &&
        releaseNotes?.map((note: ReleaseNote) => (
          <Fragment key={note?.version}>
            <VersionContainer vertical>
              <Paragraph $color="white" $fontsize="12px" $lineheight="20px">
                {t('common:profile.version')}: <Text $weight={600}>{note?.version}</Text>
              </Paragraph>
              <Paragraph $color="white" $fontsize="12px" $lineheight="20px">
                {t('common:releaseDate')}:{' '}
                <Text $weight={600}>{getLocalDateAndTime(new Date(note?.releaseDate), true)}</Text>
              </Paragraph>
            </VersionContainer>
            <ReactMarkdown remarkPlugins={[remarkGfm]}>
              {getReleaseNotesForLanguage(note, language)}
            </ReactMarkdown>
          </Fragment>
        ))}
    </ReleaseNotesContainer>
  );
};

export default ReleaseNotes;
